import { formatReportCurrency, formatReportSmartDateTime } from "@/utility/fclReportHelpers";
import { pickField } from "@/utility/fclReportFieldUtils";
import {
    clipText,
    dateReportCol,
    fileRefLinkCell,
    pickDateSort,
    pickSort,
    reportCol,
    textReportCol,
} from "./importReportColumnUtils";

const formatEtsEta = (row) => {
    const ets = pickField(row, ["etspol", "EtsPol", "ets", "ETS"], null);
    const eta = pickField(row, ["etapod", "EtaPod", "eta", "ETA"], null);
    if (!ets && !eta) return clipText("-");
    const parts = [];
    if (ets) parts.push(`ETS ${formatReportSmartDateTime(ets, "")}`);
    if (eta) parts.push(`ETA ${formatReportSmartDateTime(eta, "")}`);
    const text = parts.join(" | ");
    return (
        <span className="block min-w-0 max-w-full truncate text-[12px] tabular-nums" title={text}>
            {text}
        </span>
    );
};

const currencyReportCol = ({ key, label, fieldKeys, width = 130 }) =>
    reportCol({
        key,
        label,
        width,
        align: "right",
        render: (row) => {
            const val = pickField(row, fieldKeys, null);
            if (val === null || val === undefined || val === "") return clipText("-");
            return (
                <span className="block min-w-0 max-w-full truncate text-[13px] tabular-nums">
                    {formatReportCurrency(val)}
                </span>
            );
        },
        sortValue: (row) => {
            const val = pickField(row, fieldKeys, null);
            const num = Number(String(val).replace(/[^0-9.-]/g, ""));
            return Number.isNaN(num) ? 0 : num;
        },
    });

export const IMPORT_FILE_CANCELLATION_LIST_COLUMNS = [
    reportCol({
        key: "fileNumber",
        label: "File Number",
        width: 150,
        sticky: "left",
        render: (row) =>
            fileRefLinkCell(pickField(row, ["fileNumber", "FileNumber", "fileRefNo", "FileRefNo"])),
        getTooltip: (row) => pickField(row, ["fileNumber", "FileNumber"]) || "",
        sortValue: (row) => pickSort(row, ["fileNumber", "FileNumber"]),
    }),
    textReportCol({
        key: "bookingNo",
        label: "Booking #",
        width: 155,
        fieldKeys: ["bookingNo", "BookingNo"],
    }),
    textReportCol({
        key: "customer",
        label: "Customer",
        width: 180,
        fieldKeys: ["customer", "Customer"],
    }),
    textReportCol({
        key: "profitCenter",
        label: "Profit Center",
        width: 130,
        fieldKeys: ["profitCenter", "ProfitCenter"],
    }),
    textReportCol({
        key: "carrierPlaceOfReceipt",
        label: "Carrier Place of Receipt",
        width: 195,
        fieldKeys: [
            "carrierPlaceOfReceipt",
            "CarrierPlaceOfReceipt",
            "shipezPlaceOfReceipt",
            "ShipezPlaceOfReceipt",
        ],
    }),
    textReportCol({
        key: "portOfLoading",
        label: "Port of Loading",
        width: 175,
        fieldKeys: ["portOfLoading", "PortOfLoading"],
    }),
    textReportCol({
        key: "portOfDischarge",
        label: "Port of Discharge",
        width: 175,
        fieldKeys: ["portOfDischarge", "PortOfDischarge"],
    }),
    textReportCol({
        key: "carrierPlaceOfDelivery",
        label: "Carrier Place of Delivery",
        width: 195,
        fieldKeys: ["carrierPlaceOfDelivery", "CarrierPlaceOfDelivery"],
    }),
    reportCol({
        key: "etsEta",
        label: "ETS / ETA",
        width: 200,
        render: (row) => formatEtsEta(row),
        sortValue: (row) => pickDateSort(row, ["etspol", "EtsPol"]),
    }),
    dateReportCol({
        key: "cancelledDate",
        label: "Cancelled Date",
        width: 145,
        fieldKeys: ["cancelledDate", "CancelledDate", "cancellationDate", "CancellationDate"],
    }),
    textReportCol({
        key: "moduleType",
        label: "Import/Export/Domestic/Air",
        width: 195,
        fieldKeys: ["moduleType", "ModuleType", "officeType", "OfficeType"],
    }),
    currencyReportCol({
        key: "totalRevenue",
        label: "Total Revenue",
        fieldKeys: ["totalRevenue", "TotalRevenue"],
        width: 130,
    }),
    currencyReportCol({
        key: "totalExpense",
        label: "Total Expense",
        fieldKeys: ["totalExpense", "TotalExpense"],
        width: 130,
    }),
    currencyReportCol({
        key: "totalProfit",
        label: "Total Profit",
        fieldKeys: ["totalProfit", "TotalProfit"],
        width: 130,
    }),
    textReportCol({
        key: "cancellationReason",
        label: "Cancellation Reason",
        width: 175,
        fieldKeys: ["cancellationReason", "CancellationReason"],
    }),
    textReportCol({
        key: "cancellationReasonRemarks",
        label: "Cancellation Reason Remarks",
        width: 220,
        fieldKeys: ["cancellationReasonRemarks", "CancellationReasonRemarks"],
    }),
];

/** @deprecated Use IMPORT_FILE_CANCELLATION_LIST_COLUMNS */
export const IMPORT_FILE_CANCELLATION_COLUMNS = IMPORT_FILE_CANCELLATION_LIST_COLUMNS;
